import { useEffect, useState } from "react";

export function useAsync<T>(load: () => Promise<T>, dependencies: readonly unknown[] = []) {
  const [data, setData] = useState<T>();
  const [error, setError] = useState<unknown>();
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    let active = true;
    setError(undefined);
    setLoading(true);
    load().then((value) => active && setData(value)).catch((caught) => active && setError(caught))
      .finally(() => active && setLoading(false));
    return () => { active = false; };
  }, [...dependencies, refreshKey]);
  return {data, error, loading, refresh: () => setRefreshKey((value) => value + 1)};
}
